export const colorArray = [
    '#EF5350',
    '#D500F9',
    '#1DE9B6',
    '#F9A825',
    '#2196F3',
    '#9C27B0',
    '#B71C1C',
    '#C6FF00',
    '#CFD8DC',
    '#FDD835',
    '#009688',
    '#FF3D00',
    '#BA68C8',
    '#8BC34A',
    '#FF9E80',
    '#F06292',
    '#9E9D24',
    '#18FFFF',
    '#FFEE58',
    '#795548'
];

export default {
    colorArray
}
